import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox/Checkbox';

import './sass/add-windshield-repair-decision-to-return-url.scss';

const AddWindshieldRepairDecisionToReturnUrl = ({
  addWindshieldRepairDecisionToReturnUrl,
  setAddWindshieldRepairDecisionToReturnUrl
}) => (
  <Checkbox
    id="addWindshieldRepairDecisionToReturnUrl"
    label="Send repair decision on URL"
    name="addWindshieldRepairDecisionToReturnUrl"
    className="addWindshieldRepairDecisionToReturnUrl"
    checked={addWindshieldRepairDecisionToReturnUrl}
    onClickHandler={setAddWindshieldRepairDecisionToReturnUrl}
    tooltip={(
      <span>
        Use this feature when you want to receive repair decision on the return URL. For example for windshield replacement
        we will append a query parameter to the return URL like <u>https://example.com/?windshield=replace</u>.
        Possible values are: <b>replace</b>, <b>repairable</b>, <b>review-needed</b>, <b>no-action-required</b>.
      </span>
    )}
  />
);

AddWindshieldRepairDecisionToReturnUrl.propTypes = {
  addWindshieldRepairDecisionToReturnUrl: PropTypes.bool.isRequired,
  setAddWindshieldRepairDecisionToReturnUrl: PropTypes.func.isRequired,
};

export default AddWindshieldRepairDecisionToReturnUrl;
